import JobDescriptionComponent from '../../components/JobDescriptionForm/JobDescriptionForm'

const JobDescriptionForm = () => {
  return (
    <div>
      <JobDescriptionComponent />
    </div>
  )
}

export default JobDescriptionForm
